/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface PlanDayResponse
 */
export interface PlanDayResponse {
    /**
     * 
     * @type {string}
     * @memberof PlanDayResponse
     */
    'date'?: string;
    /**
     * 
     * @type {string}
     * @memberof PlanDayResponse
     */
    'status'?: PlanDayResponseStatusEnum;
}

export const PlanDayResponseStatusEnum = {
    Delivered: 'DELIVERED',
    Delivering: 'DELIVERING',
    Locked: 'LOCKED',
    Selected: 'SELECTED',
    NotSelected: 'NOT_SELECTED',
    Selectable: 'SELECTABLE',
    Unselectable: 'UNSELECTABLE',
    NoMenu: 'NO_MENU',
    Paused: 'PAUSED'
} as const;

export type PlanDayResponseStatusEnum = typeof PlanDayResponseStatusEnum[keyof typeof PlanDayResponseStatusEnum];


